import React from "react";
import ReactDOM from "react-dom/client";
import "./DCM/styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./DCM/styles/create_notice.css";
import { registerLicense } from "@syncfusion/ej2-base";
// import store from "./DCM/components/Store/Store";
// import store from "./DCM/components/Store/Store";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import "@fontsource/poppins"; // All weights and styles

import { Provider } from "react-redux";
import { SubStdSelProvider } from "./SubStdSelContext";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
registerLicense(
  "ORg4AjUWIQA/Gnt2VVhkQlFadVdJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkRhUX9dcX1XQmheU0I=",
);
let header = localStorage.getItem("Header");
let header1 =
  header === "Digital Class Management" || header === "" || header === null
    ? "Digital Class Management"
    : header;
localStorage.setItem("Header", header1);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <SubStdSelProvider>
        <Router>
          <AuthProvider>
            <App />
          </AuthProvider>
        </Router>
      </SubStdSelProvider>
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
